module.exports = __webpack_public_path__ + "media/images/how-img-1920-854ef7ca04b8b2972cbe5c3e0421bbc6.png";